import React, { Component } from 'react';
import fetch from './fetch';
import { identity, isNil } from 'lodash';
import { setLoading } from '../actions/appActions'

export const asyncForm = (Form) => (
  class Initable extends Component {
    state = {
      fullyLoaded: false
    }

    static defaultProps = {
      postProcess: identity
    }

    init = async (url) => {
      const { initialize, postProcess, dispatch, formData, suppressHttpError = false } = this.props;
      dispatch(setLoading(true, 'Načítání dat...'));
      if (url || formData) {
        let initialValues = {};

        // In case we have formData preloaded or provided via props, use it instead of fetching from url
        if(formData) {
          initialValues = formData;
        } else {
          try {
            const response = await fetch(url, dispatch);
            initialValues = await response.json();
          } catch (e) {
            if (!suppressHttpError) {
              throw e
            }
          }
        }

        //in case of senator or senatorAndOthers statement set type of statement
        if (
          !isNil(initialValues.official) &&
          (initialValues.official.senator || initialValues.official.senatorAndOthers) &&
          !isNil(initialValues.type)
        ) {
          let type_senator = initialValues.type;
          if (initialValues.senator) {
            type_senator = type_senator + '_PROMISED'
          }
          initialValues.type_senator = type_senator;
        }

        initialize(postProcess({ ...this.props.initialValues, ...initialValues }));
      }
      dispatch(setLoading());
      this.setState({ fullyLoaded: true });
    }

    async componentWillReceiveProps(nextProps) {
      if (this.props.url !== nextProps.url && nextProps.url) {
        await this.init(nextProps.url);
      }
    }

    async componentWillMount() {
      const { url } = this.props;
      await this.init(url);
    }

    render() {
      return <Form {...this.props} fullyLoaded={this.state.fullyLoaded} />
    }
  }
);
